import * as React from 'react'
import {
  RelatedArticleCardContainer,
  RelatedArticleCardContent, RelatedArticleCardLink, RelatedArticleCardLinkSelected,
  RelatedArticleCardSubtitle,
  RelatedArticleStyledCard
} from './RelatedArticleCard.elements'
import {ArticleRelatedLink} from "@pages/Homepage/components/ArticleSection";
import {CardTitle} from "@css/common.elements";

export type ArticleRelated = {
  title: string
  subtitle: string
  links: ArticleRelatedLink[]
}

export const RelatedArticleCard: React.FunctionComponent<ArticleRelated> = ({title, subtitle, links}) => (
  <RelatedArticleCardContainer>
    <RelatedArticleStyledCard>
      <RelatedArticleCardContent>
        <CardTitle dangerouslySetInnerHTML={{__html: title}} />
        <RelatedArticleCardSubtitle dangerouslySetInnerHTML={{__html: subtitle}}/>
        {links.map((l, idx) =>
          <React.Fragment key={l.text}>
            <br />
            { l.selected
              ? (
                <RelatedArticleCardLinkSelected
                  dangerouslySetInnerHTML={{__html: '&bull;' + '&#32;' + l.text}}
                />
              ) : (
                <div>
                  <RelatedArticleCardLink
                    href={l.link}
                    dangerouslySetInnerHTML={{__html: l.text}}
                  />
                  <br />
                </div>
              )
            }
          </React.Fragment>
        )}
      </RelatedArticleCardContent>
    </RelatedArticleStyledCard>
  </RelatedArticleCardContainer>
)
